<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="设备编号" prop="device">
                <a-input v-model="queryParam.device" placeholder="请输入设备编号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="MAC地址" prop="mac">
                <a-input v-model="queryParam.mac" placeholder="请输入MAC地址" allow-clear/>
              </a-form-item>
            </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="经销商名称" prop="name">
                  <a-input v-model="queryParam.name" placeholder="请输入经销商名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="经销商手机号" prop="mobile">
                  <a-input v-model="queryParam.mobile" placeholder="请输入经销商手机号" allow-clear/>
                </a-form-item>
              </a-col>
               <a-col :md="8" :sm="24">
                <a-form-item label="是否激活" prop="activate">
                  <a-select v-model="queryParam.activate">
                    <a-select-option :value="0">未激活</a-select-option>
                    <a-select-option :value="1">激活</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="激活手机号" prop="mobile">
                <a-input v-model="queryParam.userMobile" placeholder="请输入激活手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <!-- <template v-if="advanced"> -->

            <!-- </template> -->
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['distributor:distributor:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['distributor:distributor:edit']">
          <a-icon type="edit" />修改
        </a-button>
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['distributor:distributor:remove']">-->
<!--          <a-icon type="delete" />删除-->
<!--        </a-button>-->
        <a-button type="dashed" @click="$refs.importExcel.importExcelHandleOpen()"

                  v-hasPermi="['system:user:import']">
          <a-icon type="import" />导入
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['distributor:distributor:export']">
          <a-icon type="download" />导出
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
      <span slot="index" slot-scope="text, record,index">
       {{(current-1)*size+index+1}}
      </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="activateTime" slot-scope="text, record">
          {{ parseTime(record.activateTime) }}
        </span>
<!--        <span slot="expirationTime" slot-scope="text, record">-->
<!--          {{ parseTime(record.expirationTime) }}-->
<!--        </span>-->


        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-if="record.activate==0" v-hasPermi="['distributor:distributor:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-popconfirm v-if="record.activate==1"
          title="此操作会回退数据,请谨慎操作!"
          ok-text="确认"
          cancel-text="取消"
          @confirm="confirm(record)"
          @cancel="cancel"
        >
          <a>
            <a-icon type="edit" v-if="record.activate==1" />重置激活
          </a>
              </a-popconfirm>
          <a @click="handleDelete(record)" v-if="record.activate==0" v-hasPermi="['distributor:distributor:remove']">
            <a-icon type="delete" :style="{ color: 'red' }" />
            <span class="text-red">删除</span>
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <!-- 上传文件 -->
    <import-excel ref="importExcel" @ok="getList" />
  </page-header-wrapper>
</template>

<script>
import { pageDistributor,resetDistributor,listDistributor, delDistributor } from '@/api/distributor/distributor'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import ImportExcel from './modules/ImportExcel'

export default {
  name: 'Distributor',
  components: {
    CreateForm,
    ImportExcel
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selIndex: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        device: null,
        mac: null,
        name: null,
        mobile: null,
        activate: null,
        userId: null,
        userMobile: null,
        expirationTime: null,
        activateTime: null,
        deviceVersionId: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        // {
        //   title: '主键',
        //   dataIndex: 'id',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          align: 'center',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'index' },
         },
        {
          title: '设备编号',
          dataIndex: 'device',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'MAC地址',
          dataIndex: 'mac',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '经销商',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '经销商手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '激活',
          dataIndex: 'activate',
          ellipsis: true,
          align: 'center',
          customRender:function (text) {
            if (text == 0) {
              return "未激活";
            }else {
              return "已激活"
            }
          }
        },
        {
          title: '激活用户',
          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '激活手机号',
          dataIndex: 'userMobile',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '绑定用户id,外键{zb_user.id}',
        //   dataIndex: 'userId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '设备版本id,外键{zb_device_version.id}',
        //   dataIndex: 'deviceVersionId',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '激活时间',
          dataIndex: 'activateTime',
          scopedSlots: { customRender: 'activateTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '会员到期时间',
          dataIndex: 'expirationTime',
          // scopedSlots: { customRender: 'expirationTime' },
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '插入时间',
        //   dataIndex: 'createTime',
        //   scopedSlots: { customRender: 'createTime' },
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   ellipsis: true,
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '10%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    confirm(row){
      console.log(row,"row")
      resetDistributor({id:row.id}).then(response => {
        this.getList()
        this.$message.success(
          '重置成功',
          3
        )
      })
    },
    cancel(){
      this.$message.error('已取消');
    },
    importExcelHandle(){
      this.$nextTick(() =>{
        this.$refs.importExcel.importExcelHandleOpen()
      })

    },

    /** 查询经销商列表 */
    getList () {
      this.loading = true
     pageDistributor(this.queryParam).then(response => {
        this.list = response.data.records
        this.list.forEach((item,i)=>{
          item.index=i+1
        })
        this.total = response.data.total
        this.current = response.data.current
        this.size = response.data.size
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        device: undefined,
        mac: undefined,
        name: undefined,
        mobile: undefined,
        activate: undefined,
        userId: undefined,
        userMobile: undefined,
        activateTime: undefined,
        expirationTime: undefined,
        deviceVersionId: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {

      console.log(selectedRowKeys, selectedRows)
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.selIndex =  this.selectedRows.map(item => item.index)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      const index = row.index || this.selIndex
      if(row.index){
        this.selIndex.push(row.index)
      }
      console.log(index,this.selIndex,"dfsdf")
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中序号为' + index + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          // that.selIndex.map(index => data.push({"index":index}))
          return delDistributor(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('distributor/distributor/DistributorExport', {
            ...that.queryParam
          }, `经销商_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
